export default __webpack_public_path__ + "static/media/Image2.e18fc13e.png";